
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const setting = namespace("setting");
const app = namespace("app");
@Component({})
export default class PermissionEdit extends Vue {
  @setting.Action getPcPermissionList;
  @setting.Action createRole;
  @setting.Action updateRole;
  @setting.Action getRoleDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  get breadData() {
    return [
      { name: this.$t("permission.role-list"), path: "/setting/permission" },
      { name: this.$t("permission.role-detail") }
    ];
  }
  get isAdd() {
    return this.$route.name === "permissionAdd";
  }
  get isView() {
    return this.$route.name === "permissionView";
  }
  permissionData: any = {
    roleName: ""
  };
  permissionDataRules: any = {
    roleName: [{ required: true, message: t("permission.name-empty-tips"), trigger: "blur" }]
  };
  activeTabName: string = "first";
  treeProps = {
    label: "resourceName"
  };
  treeLoading: boolean = false;
  pcPermList: any[] = [];
  appPermList: any[] = [];
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        if (this.isAdd) {
          this.addRole();
        } else {
          this.editRole();
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  addRole() {
    this.btnStartLoading();
    this.createRole({
      roleName: this.permissionData.roleName,
      resourcesList: [...this.getFilterPcTree(), ...this.getFilterAppTree()]
    })
      .then(() => {
        this.$message.success(this.$t("base.success") as any);
        this.$router.push(`/setting/permission`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  editRole() {
    this.btnStartLoading();
    this.updateRole({
      resourcesList: [...this.getFilterPcTree(), ...this.getFilterAppTree()],
      roleCode: this.$route.params.id,
      roleName: this.permissionData.roleName
    })
      .then(() => {
        this.$message.success(this.$t("base.success") as any);
        this.$router.push(`/setting/permission`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }

  getFilterPcTree() {
    return (this.$refs["pcTree"] as any).getCheckedNodes(false, true);
  }
  getFilterAppTree() {
    return (this.$refs["appTree"] as any).getCheckedNodes(false, true);
  }
  viewFilterTree(orginalTree, selectedKetys) {
    const tree = orginalTree;
    let f = function (treeArr) {
      for (let index = 0; index < treeArr.length; index++) {
        const element = treeArr[index];
        if (selectedKetys.includes(element.resourceCode)) {
          element.disabled = true;
          if (element.children) {
            f(element.children);
          }
        } else {
          treeArr.splice(index, 1);
          index--;
        }
      }
    };
    f(tree);
    return tree;
  }
  created() {
    this.init();
  }
  async init() {
    this.treeLoading = true;
    let pcTreeData = await this.getPcPermissionList({
      resourceParent: "pc_root"
    });
    let appTreeData = await this.getPcPermissionList({
      resourceParent: "app_root"
    });
    if (!this.isView) {
      this.pcPermList = pcTreeData.data.list;
      this.appPermList = appTreeData.data.list;
    }
    if (!this.isAdd) {
      const rolePermDetail = await this.getRoleDetail({
        roleCode: this.$route.params.id
      });
      this.permissionData.roleName = rolePermDetail.data.roleName;
      let editListKeys = [];
      let viewListKeys = [];
      try {
        rolePermDetail.data.resourcesList.forEach(item => {
          if (item.leafNode) {
            editListKeys.push(item.resourceCode);
          }
          viewListKeys.push(item.resourceCode);
        });
      } catch (e) {
        console.log(e);
      }
      if (this.isView) {
        this.pcPermList = this.viewFilterTree(pcTreeData.data.list, viewListKeys);
        this.appPermList = this.viewFilterTree(appTreeData.data.list, viewListKeys);
      }
      (this.$refs["pcTree"] as any).setCheckedKeys(editListKeys, false);
      (this.$refs["appTree"] as any).setCheckedKeys(editListKeys, false);
    }
    this.treeLoading = false;
  }
}
